function initBundlePickerFooter() {
  const footer = document.querySelector('.bundle-picker-footer');
  if (!footer) return;

  const progressBar = footer.querySelector('.bundle-picker-footer__progress-bar');
  if (progressBar) {
    progressBar.style.width = '0%';
  }

  for (let i = 1; i <= 3; i++) {
    const goalElement = footer.querySelector('.bundle-picker-footer__goal-' + i);
    if (!goalElement) continue;

    goalElement.classList.remove('is-reached');

    const iconImg = goalElement.querySelector('.bundle-picker-footer__goal-icon-img');
    if (iconImg) {
      const iconInactive = goalElement.getAttribute('data-icon-inactive');
      const iconDefault = goalElement.getAttribute('data-icon-default');
      const newIconSrc = iconInactive || iconDefault;
      if (newIconSrc) {
        iconImg.src = newIconSrc;
      }
    }
  }

  const progressTextTop = footer.querySelector('.bundle-picker-footer__progress-text');
  const progressTextBottom = footer.querySelector('.bundle-picker-footer__progress-subtext');
  if (progressTextTop) {
    const startText = footer.getAttribute('data-stage-start-top') || '';
    if (startText) {
      progressTextTop.innerHTML = startText;
    }
  }
  if (progressTextBottom) {
    const startText = footer.getAttribute('data-stage-start-bottom') || '';
    if (startText) {
      progressTextBottom.innerHTML = startText;
    }
  }
}

function initBundlePickerFooterSticky() {
  const originalFooter = document.querySelector('.bundle-picker-footer');
  if (!originalFooter) {
    const existingSticky = document.querySelector('.bundle-picker-footer--sticky-element');
    if (existingSticky) {
      existingSticky.remove();
    }
    return;
  }

  let stickyFooter = document.querySelector('.bundle-picker-footer--sticky-element');
  if (!stickyFooter) {
    stickyFooter = originalFooter.cloneNode(true);
    stickyFooter.classList.add('bundle-picker-footer--sticky-element');
    stickyFooter.classList.add('bundle-picker-footer--sticky');
    document.body.appendChild(stickyFooter);
  }

  let footerOriginalTop = null;
  let footerOriginalBottom = null;
  let ticking = false;
  let isStickyVisible = false;

  function attachCheckoutButtonListener() {
    const stickyCheckoutButton = stickyFooter.querySelector('.footer-checkout-button');
    const originalCheckoutButton = originalFooter.querySelector('.footer-checkout-button');

    if (stickyCheckoutButton && originalCheckoutButton && stickyCheckoutButton.parentNode) {
      const newButton = stickyCheckoutButton.cloneNode(true);
      stickyCheckoutButton.parentNode.replaceChild(newButton, stickyCheckoutButton);

      newButton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (originalCheckoutButton) {
          originalCheckoutButton.click();
        }
      });
    }
  }

  function updateFooterOriginalPosition() {
    const rect = originalFooter.getBoundingClientRect();
    footerOriginalTop = rect.top + window.scrollY;
    footerOriginalBottom = rect.bottom + window.scrollY;
  }

  function syncFooterContent() {
    const originalContent = originalFooter.innerHTML;
    stickyFooter.innerHTML = originalContent;
    const stickyImageWrapper = stickyFooter.querySelector('.bundle-picker-footer__image-wrapper');
    if (stickyImageWrapper) {
      stickyImageWrapper.style.display = 'none';
    }
    attachCheckoutButtonListener();
  }

  attachCheckoutButtonListener();

  function checkStickyState() {
    updateFooterOriginalPosition();

    if (footerOriginalTop === null || footerOriginalBottom === null) {
      updateFooterOriginalPosition();
      if (footerOriginalTop === null || footerOriginalBottom === null) {
        ticking = false;
        return;
      }
    }

    const scrollY = window.scrollY;
    const viewportHeight = window.innerHeight;
    const viewportBottom = scrollY + viewportHeight;

    const shouldBeSticky = viewportBottom < footerOriginalBottom;

    if (shouldBeSticky && !isStickyVisible) {
      syncFooterContent();
      stickyFooter.style.display = 'flex';
      isStickyVisible = true;
    } else if (!shouldBeSticky && isStickyVisible) {
      stickyFooter.style.display = 'none';
      isStickyVisible = false;
    }

    ticking = false;
  }

  function handleScroll() {
    if (!ticking) {
      window.requestAnimationFrame(checkStickyState);
      ticking = true;
    }
  }

  updateFooterOriginalPosition();
  stickyFooter.style.display = 'none';
  checkStickyState();

  window.addEventListener('scroll', handleScroll, { passive: true });

  window.addEventListener(
    'resize',
    () => {
      footerOriginalTop = null;
      footerOriginalBottom = null;
      checkStickyState();
    },
    { passive: true }
  );

  const observer = new MutationObserver(() => {
    if (isStickyVisible) {
      syncFooterContent();
    }
  });

  observer.observe(originalFooter, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style'],
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initBundlePickerFooter();
    initBundlePickerFooterSticky();
  });
} else {
  initBundlePickerFooter();
  initBundlePickerFooterSticky();
}

if (typeof document.addEventListener !== 'undefined') {
  document.addEventListener('shopify:section:load', function (event) {
    if (event.detail.sectionId && event.detail.sectionId.includes('bundle-picker')) {
      requestAnimationFrame(() => {
        initBundlePickerFooter();
        initBundlePickerFooterSticky();
      });
    }
  });

  document.addEventListener('cart:updated', function () {
    requestAnimationFrame(() => {
      initBundlePickerFooter();
      initBundlePickerFooterSticky();
    });
  });

  document.addEventListener('bundle-picker:section-updated', function () {
    requestAnimationFrame(() => {
      initBundlePickerFooter();
      initBundlePickerFooterSticky();
    });
  });

  document.addEventListener('shopify:section:morph', function (event) {
    if (event.detail && event.detail.sectionId && event.detail.sectionId.includes('bundle-picker')) {
      requestAnimationFrame(() => {
        initBundlePickerFooter();
        initBundlePickerFooterSticky();
      });
    }
  });
}
